import React from 'react'
import { Formik, Form, Field } from 'formik'
import * as Yup from 'yup'
import { CodeInput } from './CodeInput'
import { AutoSubmitListener } from './AutoSubmitListener'
import { Notification } from '@local/do-secundo-notification'
import { Progress } from '@local/do-secundo-progress'
export interface CodeConfirmationFormProps {
  testId?: string
  handleSubmit: (code: string, setSubmitting: (boolean) => void) => void
  numFields: number
  codeClassName?: string
  resetFocusAfterCompletion?: boolean
  spaceBetweenHyphens?: number
  idPrefix?: string
}

export const CodeConfirmationForm = ({
  testId = 'code-confirmation-form',
  handleSubmit,
  numFields = 6,
  codeClassName = '',
  resetFocusAfterCompletion = true,
  spaceBetweenHyphens = 3,
  idPrefix
}: CodeConfirmationFormProps) => {
  const codeValidationSchema = Yup.object({
    codeValues: Yup.string()
      .matches(/^\d+$/)
      .min(numFields)
      .required('Not enough fields filled')
  })

  return (
    <div className={codeClassName}>
      <Formik
        validationSchema={codeValidationSchema}
        initialValues={{ codeValues: '' }}
        enableReinitialize
        onSubmit={async (
          { codeValues },
          { setError, setSubmitting, setFieldValue }
        ) => {
          try {
            await handleSubmit(codeValues, setSubmitting)
          } catch (error) {
            setError(error)
            setFieldValue('codeValues', '')
          } finally {
            setSubmitting(false)
          }
        }}
      >
        {(formik) => {
          const { error, isSubmitting, values } = formik
          return (
            <Form
              data-testid={testId}
              className='flex flex-col items-center justify-center'
            >
              <AutoSubmitListener
                formik={formik}
                canSubmit={values.codeValues.trim().length === numFields}
              />
              {isSubmitting ? (
                <Progress />
              ) : (
                <div className='flex items-center py-4'>
                  <Field
                    component={CodeInput}
                    numFields={numFields}
                    resetFocusAfterCompletion={resetFocusAfterCompletion}
                    spaceBetweenHyphens={spaceBetweenHyphens}
                    autoFocus={true}
                    idPrefix={idPrefix}
                  />
                </div>
              )}
              {error && (
                <div
                  className='py-2 '
                  style={{ visibility: isSubmitting ? 'hidden' : 'initial' }}
                >
                  <Notification severity='error'>{error.message}</Notification>
                </div>
              )}
            </Form>
          )
        }}
      </Formik>
    </div>
  )
}
